var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"size":"regular","type":"primary","text":_vm.buttonText},on:{"click":_vm.startRegistration}})
}
var staticRenderFns = []

export { render, staticRenderFns }